import React, { useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import {
  CSpinner,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CBadge,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
} from '@coreui/react';

const AlertsHistory = ({ loading, alerts }) => {
  const [previewAlert, setPreviewAlert] = useState(null);

  if (loading) {
    return (
      <div className="text-center p-5">
        <CSpinner color="primary" />
      </div>
    );
  }

  if (alerts.length === 0) {
    return (
      <p className="text-center text-muted mt-5 pt-5">
        Инцидентов нет.
      </p>
    );
  }

  return (
    <>
      <div className="table-responsive border rounded bg-white">
        <CTable hover align="middle" className="mb-0" small>
          <CTableHead color="light">
            <CTableRow>
              <CTableHeaderCell>Время</CTableHeaderCell>
              <CTableHeaderCell>Техника</CTableHeaderCell>
              <CTableHeaderCell>Проблема</CTableHeaderCell>
              <CTableHeaderCell>Детали</CTableHeaderCell>
              <CTableHeaderCell className="text-center">Скриншот</CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {alerts.map((a) => (
              <CTableRow key={a.id}>
                <CTableDataCell className="text-nowrap small text-muted">
                  {dayjs(a.device_timestamp).format('DD.MM.YY HH:mm:ss')}
                </CTableDataCell>
                <CTableDataCell className="fw-bold text-dark">
                  {a.device_name}
                </CTableDataCell>
                <CTableDataCell>
                  <CBadge color="danger">{a.category_display}</CBadge>
                </CTableDataCell>
                <CTableDataCell className="small text-muted">
                  {a.message}
                </CTableDataCell>
                <CTableDataCell className="text-center">
                  {a.screenshot ? (
                    <img
                      src={a.screenshot}
                      alt="Скриншот"
                      onClick={() => setPreviewAlert(a)}
                      title="Нажмите для увеличения"
                      style={{
                        width: '56px',
                        height: '38px',
                        objectFit: 'cover',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        border: '1px solid #dee2e6',
                      }}
                    />
                  ) : (
                    <span className="text-muted">-</span>
                  )}
                </CTableDataCell>
              </CTableRow>
            ))}
          </CTableBody>
        </CTable>
      </div>

      <CModal
        visible={Boolean(previewAlert)}
        onClose={() => setPreviewAlert(null)}
        size="xl"
        alignment="center"
      >
        <CModalHeader closeButton className="bg-light">
          <CModalTitle className="fs-6 fw-bold">
            {previewAlert?.device_name} — {previewAlert?.category_display} (
            {previewAlert && dayjs(previewAlert.device_timestamp).format('DD.MM.YYYY HH:mm:ss')})
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0 bg-black text-center">
          {previewAlert?.screenshot && (
            <img
              src={previewAlert.screenshot}
              alt="Скриншот инцидента"
              style={{
                width: '100%',
                height: 'auto',
                maxHeight: '82vh',
                objectFit: 'contain',
              }}
            />
          )}
        </CModalBody>
      </CModal>
    </>
  );
};

AlertsHistory.propTypes = {
  loading: PropTypes.bool.isRequired,
  alerts: PropTypes.array.isRequired,
};

export default AlertsHistory;